// extracted by mini-css-extract-plugin
export var banner = "_3q-0";
export var icon = "_3q-1";
export var message = "_3q-2";